import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { CoreService } from './core/services/core.service';
import { NotifactionService } from './core/services/notification.service';
import { Maintenance } from './features/maintenance/maintenance';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, Maintenance],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Default,
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('npr-agent');
  private notificationService = inject(NotifactionService);
  private coreService = inject(CoreService);

  protected readonly isMaintenanceMode = computed(
    () => !!this.coreService.appConfig()?.maintenance?.partner,
  );
}
